import React from 'react';

import { serverService } from '../../_services/server.service';
import { toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ItemsSelect from '../_other/ItemsSelect';

import ModalContent from "../_modals/ModalContent";
import ModalTosSimple from "../_modals/ModalTosSimple";
import { RouteComponentProps } from 'react-router-dom';
import './PaymentPage.scss';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements, ElementsConsumer, } from '@stripe/react-stripe-js';
import { config } from '../../_helpers/C';
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import sha1 from 'sha1'
const qs = require('query-string');
const stripePromise = loadStripe(config.STRIPE_PUBLIC_KEY);

const CARD_ELEMENT_OPTIONS = { hidePostalCode: true, style: { padding: '10px 12px', iconStyle: 'solid', base: { iconColor: 'rgb(240, 57, 122)', color: '#0a1727', fontFamily: '"Inter', fontSmoothing: 'antialiased', fontSize: '16px', '::placeholder': { color: '#AFAFAF', }, }, invalid: { color: '#94180f', iconColor: '#94180f', }, }, };

interface MyPropsStripe {
  stripe: any;
  elements: any;
  onCardChange(card: any): any;
}

interface MyStateStripe { }

class StripeCardComponent extends React.Component<MyPropsStripe, MyStateStripe>
{
  onChange = async (event) => {
    const { stripe, elements } = this.props;
    let card = elements.getElement(CardElement);
    this.props.onCardChange(card);
  };

  render() { return (<CardElement options={CARD_ELEMENT_OPTIONS} onChange={this.onChange} />); }
}

interface MyProps {
  stripe: any;
  elements: any;
  handleResult: any;
}
interface MyState {
  submitted: boolean;
  savecard: boolean;
  loading: boolean;
  loadingVat: boolean;
  error: string;
  formFields: any;
  licenseType: number;
  virtualVoxNum: number;
  physicalVoxNum: number;
  modalContent: boolean;
  modalTos: boolean;
  the_props: any;
  suggestion_counter: number;
  vatInfo: any;
  vat_exempt: boolean;
  disableVat: boolean;
  vatInput: any; 
  user: any;
  company: any;
}
class PaymentPage extends React.Component<MyProps & RouteComponentProps, MyState> {
  private countriesObj;
  private euCountries;
  constructor(props) {
    super(props);

    this.euCountries = ['BE','ES','DE','FR','NL','IT','AT','CZ','DK','EL','MT','CY','IE','LV','PL','PT','RO','SI','HU','HR','SI','FI','SK','SE'];

    this.countriesObj = { "AF": "Afghanistan", "AL": "Albania", "DZ": "Algeria", "AS": "American Samoa", "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AQ": "Antarctica", "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", "BS": "Bahamas (the)", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia (Plurinational State of)", "BQ": "Bonaire, Sint Eustatius and Saba", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BV": "Bouvet Island", "BR": "Brazil", "IO": "British Indian Ocean Territory (the)", "BN": "Brunei Darussalam", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "CV": "Cabo Verde", "KH": "Cambodia", "CM": "Cameroon", "CA": "Canada", "KY": "Cayman Islands (the)", "CF": "Central African Republic (the)", "TD": "Chad", "CL": "Chile", "CN": "China", "CX": "Christmas Island", "CC": "Cocos (Keeling) Islands (the)", "CO": "Colombia", "KM": "Comoros (the)", "CD": "Congo (the Democratic Republic of the)", "CG": "Congo (the)", "CK": "Cook Islands (the)", "CR": "Costa Rica", "HR": "Croatia", "CU": "Cuba", "CW": "Curaçao", "CY": "Cyprus", "CZ": "Czechia", "CI": "Côte d'Ivoire", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic (the)", "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia", "SZ": "Eswatini", "ET": "Ethiopia", "FK": "Falkland Islands (the) [Malvinas]", "FO": "Faroe Islands (the)", "FJ": "Fiji", "FI": "Finland", "FR": "France", "GF": "French Guiana", "PF": "French Polynesia", "TF": "French Southern Territories (the)", "GA": "Gabon", "GM": "Gambia (the)", "GE": "Georgia", "DE": "Germany", "GH": "Ghana", "GI": "Gibraltar", "GR": "Greece", "GL": "Greenland", "GD": "Grenada", "GP": "Guadeloupe", "GU": "Guam", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea", "GW": "Guinea-Bissau", "GY": "Guyana", "HT": "Haiti", "HM": "Heard Island and McDonald Islands", "VA": "Holy See (the)", "HN": "Honduras", "HK": "Hong Kong", "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IR": "Iran (Islamic Republic of)", "IQ": "Iraq", "IE": "Ireland", "IM": "Isle of Man", "IL": "Israel", "IT": "Italy", "JM": "Jamaica", "JP": "Japan", "JE": "Jersey", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "KP": "Korea (the Democratic People's Republic of)", "KR": "Korea (the Republic of)", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Lao People's Democratic Republic (the)", "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macao", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MH": "Marshall Islands (the)", "MQ": "Martinique", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "FM": "Micronesia (Federated States of)", "MD": "Moldova (the Republic of)", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MS": "Montserrat", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands (the)", "NC": "New Caledonia", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger (the)", "NG": "Nigeria", "NU": "Niue", "NF": "Norfolk Island", "MP": "Northern Mariana Islands (the)", "NO": "Norway", "OM": "Oman", "PK": "Pakistan", "PW": "Palau", "PS": "Palestine, State of", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines (the)", "PN": "Pitcairn", "PL": "Poland", "PT": "Portugal", "PR": "Puerto Rico", "QA": "Qatar", "MK": "Republic of North Macedonia", "RO": "Romania", "RU": "Russian Federation (the)", "RW": "Rwanda", "RE": "Réunion", "BL": "Saint Barthélemy", "SH": "Saint Helena, Ascension and Tristan da Cunha", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia", "MF": "Saint Martin (French part)", "PM": "Saint Pierre and Miquelon", "VC": "Saint Vincent and the Grenadines", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tome and Principe", "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SX": "Sint Maarten (Dutch part)", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa", "GS": "South Georgia and the South Sandwich Islands", "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan (the)", "SR": "Suriname", "SJ": "Svalbard and Jan Mayen", "SE": "Sweden", "CH": "Switzerland", "SY": "Syrian Arab Republic", "TW": "Taiwan", "TJ": "Tajikistan", "TZ": "Tanzania, United Republic of", "TH": "Thailand", "TL": "Timor-Leste", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad and Tobago", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TC": "Turks and Caicos Islands (the)", "TV": "Tuvalu", "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates (the)", "GB": "United Kingdom of Great Britain and Northern Ireland (the)", "UM": "United States Minor Outlying Islands (the)", "US": "United States of America (the)", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VE": "Venezuela (Bolivarian Republic of)", "VN": "Viet Nam", "VG": "Virgin Islands (British)", "VI": "Virgin Islands (U.S.)", "WF": "Wallis and Futuna", "EH": "Western Sahara", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe", "AX": "Åland Islands" };
    
    let license = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).license;
    let virtualVoxNum = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).virtualVoxNum;
    let physicalVoxNum = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).physicalVoxNum;

    if (!license) {
      license = 'self-starter';
    }
    if (!virtualVoxNum) {
      virtualVoxNum = 1;
    }
    if (!physicalVoxNum) {
      physicalVoxNum = 0;
    }
    let licenseType = 0;
    if (license == 'self-starter') {
      licenseType = 1;
    } else if (license == 'standard') {
      licenseType = 2;
    } else if (license == 'enterprise') {
      licenseType = 3;
    }
    if(props.location.state && props.location.state.index){
      licenseType = props.location.state.index
    }
    let userStr = localStorage.getItem('user');
   
    let userObj = {Username:""};
    
    if(userStr) {
      userObj = JSON.parse(userStr);
    }
  
    this.state = {
      vat_exempt: false,
      user: userObj,
      company: {},
      suggestion_counter: 0,
      the_props: this.props.history.location,
      savecard: false,
      submitted: false,
      loading: false,
      loadingVat: false,
      error: '',
      formFields: { Username: userObj.Username, Password: '', Email: userObj.Username, billing_address: '', card_name: '', CountryCode: '', vat_number: '', vat_exempt: false, },
      licenseType: licenseType,
      disableVat: false,
      virtualVoxNum: virtualVoxNum,
      physicalVoxNum: physicalVoxNum,
      modalContent: false,
      modalTos: false,
      vatInfo: {
        tax_rate_percentage: 0,
      },
      vatInput: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCountry = this.handleChangeCountry.bind(this);
    this.doFetchCompany = this.doFetchCompany.bind(this);
    this.disableVat = this.disableVat.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleModalTosSimple = this.handleModalTosSimple.bind(this);
    this.onChangeSaveCard = this.onChangeSaveCard.bind(this);
    this.requestVatValidation = this.requestVatValidation.bind(this);
    this.defaultVat = this.defaultVat.bind(this);
    this.handleVatChange = this.handleVatChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onCardChange = this.onCardChange.bind(this);
    this.incrementSuggestionCounter = this.incrementSuggestionCounter.bind(this);
    this.decrementSuggestionCounter = this.decrementSuggestionCounter.bind(this);

  }


  handleSubmit(evt) {
    evt.preventDefault();
    let formFields = this.state.formFields;
    let card = formFields.card;
    const { licenseType, virtualVoxNum, physicalVoxNum } = this.state;

    if (card == undefined || card == null) {
      toast.error(i18n.t('trans_33_msg_card_info_not_correct'));
      return;
    }
    if (licenseType < -1 || virtualVoxNum < 0 || physicalVoxNum < 0) {
      toast.error(i18n.t('trans_33_msg_warning_pricing_variables_not_defined'));
      return;
    }
    this.setState({ loading: true });
    stripePromise.then((stripe) => {
      return stripe.createPaymentMethod({
        type: 'card',
        card: card,
      });
    })
      .then((result) => {
        if (result.paymentMethod === undefined || result.paymentMethod.id.length == 0) {
          toast.error(i18n.t('trans_33_msg_error_card_failed'));
          throw 'Card failed';
        }
        
        const dd = (name) => {
          let el = document.querySelector(`[name="${name}"]`).value;
          return el;
        }

        formFields.PaymentMethodId = result.paymentMethod.id;
        formFields.licenseType = licenseType;
        formFields.virtualVoxNum = virtualVoxNum;
        formFields.physicalVoxNum = physicalVoxNum;
        formFields.monthlyPrice    = dd('monthlyPrice');
        formFields.paymentNowPrice = dd('paymentNowPrice');

        let newFormFields = Object.assign({}, formFields);
        delete newFormFields.card;
        this.setState({ formFields: newFormFields });

        this.props.history.push('/middleware', {state: this.state});


        //aqui
      
        // serverService.paymentsSavePaymentMethod(formFields.PaymentMethodId, formFields.card_name).then(
        //   (response) => {
        //     if (response != undefined) {
        //       if (response.status == 1 || response.status == '1') {
        //         this.setState({
        //           submitted: false,
        //           loading: false,
        //           formFields: { Username: '', Password: '', Email: '', },
        //         });
  
        //         if (response.data == undefined || response.data.length == 0) {
        //           this.setState({ error: i18n.t('trans_33_msg_server_error') });
        //         } else {
        //           toast.success(i18n.t('trans_33_msg_registration_completed'));
  
        //           let user = response.data[0];
        //           localStorage.setItem('user', JSON.stringify(user));
  
        //           setTimeout(function () {
        //             window.location.href = '/home';
        //           }, 3000);
        //         }
        //       } else {
        //         toast.warn(response.message);
  
        //         this.setState({ submitted: false, loading: false });
        //       }
        //     }
        //   },
        //   (error) => {
        //     this.setState({ submitted: false, loading: false });
        //     console.log(error);
        //   }
        // );
      })
  
  }


  incrementSuggestionCounter() {
    this.setState({
      suggestion_counter: this.state.suggestion_counter + 1,
      physicalVoxNum: this.state.suggestion_counter + 1,
    });
  }
  decrementSuggestionCounter() {
    if ((this.state.suggestion_counter - 1) > 0) {
      this.setState({
        suggestion_counter: this.state.suggestion_counter - 1,
        physicalVoxNum: this.state.suggestion_counter - 1,
      });
    }
    else {
      this.setState({
        suggestion_counter: 0,
        physicalVoxNum: 0,
      });
    }

  }
  handleModalShow() {
    this.setState({
      modalContent: !this.state.modalContent,
    });
  }  
  handleModalTosSimple() {
    this.setState({
      modalTos: !this.state.modalTos,
    });
  }
  disableVat() {
    this.setState({
      vat_exempt: !this.state.vat_exempt,
      vatInfo: {tax_rate_percentage: 0},
      vatInput: '',
    });
  }

  defaultVat() {
    this.setState({ vatInfo: { tax_rate_percentage: 0.21 } });
    return true
  }
  handleChange(e) {
    const { name, value } = e.target;
    let formFields = this.state.formFields;
    formFields[name] = value;
    this.setState({ formFields: formFields });
  }
  handleChangeCountry(e) {
    const { name, value } = e.target;
    let formFields = this.state.formFields;
    formFields[name] = value;
    this.setState({ vatInfo: { tax_rate_percentage: 0.21 } });
    this.setState({ formFields: formFields });
  }
  onChangeSaveCard = async (event) => {
    this.setState({
      savecard: !this.state.savecard
    });
  }

  componentDidMount() {
    if(localStorage.getItem('user') == null) {
    this.props.history.push({pathname:"/registration", state:{the_props: this.state.the_props.state}});
    }
    this.doFetchCompany();
  }
  componentDidUpdate() {
    
  }

  render() {  
    const { formFields, submitted, loading, loadingVat, error, the_props, suggestion_counter, vatInfo, licenseType, vat_exempt } = this.state;
    const prop_info = this.state.the_props.state.cardinfo ? this.state.the_props.state.cardinfo : this.state.the_props.state.esse;
    const isMonthly = this.state.the_props.state.isMonthly;
    const monthlyPrice = prop_info.defaultPrice;
    const monthlyPriceWithoutVat = (monthlyPrice * (vatInfo.tax_rate_percentage > 0 ? /*(1+vatInfo.tax_rate_percentage)*/(1) : (1) )).toFixed(2) + (prop_info.currency === 'eur' ? '€' : prop_info.currency);
    const oneTimePrice = (monthlyPrice * (vatInfo.tax_rate_percentage > 0 ? /*(1+vatInfo.tax_rate_percentage)*/(1) : (0) ))
    const paymentNowPrice =  ((/*monthlyPrice+*/(suggestion_counter*250)) * (vatInfo.tax_rate_percentage > 0 ? (1+(1*vatInfo.tax_rate_percentage)) : (1) )).toFixed(2);

   

    const Email = formFields.Email;
    const card_name = formFields.card_name;
    const CountryCode = formFields.CountryCode;
    const billing_address = formFields.billing_address;



    const backIcon = (<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H7C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z" fill="black" /> <path d="M7.41383 16L15.7078 24.292C15.8956 24.4798 16.0011 24.7344 16.0011 25C16.0011 25.2655 15.8956 25.5202 15.7078 25.708C15.5201 25.8958 15.2654 26.0012 14.9998 26.0012C14.7343 26.0012 14.4796 25.8958 14.2918 25.708L5.29183 16.708C5.19871 16.6151 5.12482 16.5047 5.07441 16.3832C5.024 16.2618 4.99805 16.1315 4.99805 16C4.99805 15.8684 5.024 15.7382 5.07441 15.6167C5.12482 15.4952 5.19871 15.3849 5.29183 15.292L14.2918 6.29198C14.4796 6.10421 14.7343 5.99872 14.9998 5.99872C15.2654 5.99872 15.5201 6.10421 15.7078 6.29198C15.8956 6.47975 16.0011 6.73443 16.0011 6.99998C16.0011 7.26553 15.8956 7.52021 15.7078 7.70798L7.41383 16Z" fill="black" /> </svg>)
    const questionMarkIcon = (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.125 12C20.125 14.1549 19.269 16.2215 17.7452 17.7452C16.2215 19.269 14.1549 20.125 12 20.125C9.84512 20.125 7.77849 19.269 6.25476 17.7452C4.73102 16.2215 3.875 14.1549 3.875 12C3.875 9.84512 4.73102 7.77849 6.25476 6.25476C7.77849 4.73102 9.84512 3.875 12 3.875C14.1549 3.875 16.2215 4.73102 17.7452 6.25476C19.269 7.77849 20.125 9.84512 20.125 12ZM22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12ZM9.8125 15.125C9.56386 15.125 9.3254 15.2238 9.14959 15.3996C8.97377 15.5754 8.875 15.8139 8.875 16.0625C8.875 16.3111 8.97377 16.5496 9.14959 16.7254C9.3254 16.9012 9.56386 17 9.8125 17H14.1875C14.4361 17 14.6746 16.9012 14.8504 16.7254C15.0262 16.5496 15.125 16.3111 15.125 16.0625C15.125 15.8139 15.0262 15.5754 14.8504 15.3996C14.6746 15.2238 14.4361 15.125 14.1875 15.125H12.9375V10.75H10.75C10.5014 10.75 10.2629 10.8488 10.0871 11.0246C9.91127 11.2004 9.8125 11.4389 9.8125 11.6875C9.8125 11.9361 9.91127 12.1746 10.0871 12.3504C10.2629 12.5262 10.5014 12.625 10.75 12.625H11.0625V15.125H9.8125ZM12 9.5C12.3315 9.5 12.6495 9.3683 12.8839 9.13388C13.1183 8.89946 13.25 8.58152 13.25 8.25C13.25 7.91848 13.1183 7.60054 12.8839 7.36612C12.6495 7.1317 12.3315 7 12 7C11.6685 7 11.3505 7.1317 11.1161 7.36612C10.8817 7.60054 10.75 7.91848 10.75 8.25C10.75 8.58152 10.8817 8.89946 11.1161 9.13388C11.3505 9.3683 11.6685 9.5 12 9.5Z" fill="#35BFF4" /> </svg>)
    const imgLoading = ('data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==')
    const decrementIcon = <svg onClick={this.decrementSuggestionCounter} style={{ position: 'absolute', marginTop: 20, marginLeft: 8 }} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.5 16.2475H7.5C7.16848 16.2475 6.85054 16.1158 6.61612 15.8814C6.3817 15.647 6.25 15.329 6.25 14.9975C6.25 14.666 6.3817 14.348 6.61612 14.1136C6.85054 13.8792 7.16848 13.7475 7.5 13.7475H22.5C22.8315 13.7475 23.1495 13.8792 23.3839 14.1136C23.6183 14.348 23.75 14.666 23.75 14.9975C23.75 15.329 23.6183 15.647 23.3839 15.8814C23.1495 16.1158 22.8315 16.2475 22.5 16.2475Z" fill="black" fill-opacity="0.5" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" stroke="#EEEEEE" />
    </svg>
    const incrementIcon = <svg onClick={this.incrementSuggestionCounter} style={{ background: 'white', position: 'absolute', marginTop: 20, marginLeft: -36 }} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21 16H16V21C16 21.2652 15.8946 21.5196 15.7071 21.7071C15.5196 21.8946 15.2652 22 15 22C14.7348 22 14.4804 21.8946 14.2929 21.7071C14.1054 21.5196 14 21.2652 14 21V16H9C8.73478 16 8.48043 15.8946 8.29289 15.7071C8.10536 15.5196 8 15.2652 8 15C8 14.7348 8.10536 14.4804 8.29289 14.2929C8.48043 14.1054 8.73478 14 9 14H14V9C14 8.73478 14.1054 8.48043 14.2929 8.29289C14.4804 8.10536 14.7348 8 15 8C15.2652 8 15.5196 8.10536 15.7071 8.29289C15.8946 8.48043 16 8.73478 16 9V14H21C21.2652 14 21.5196 14.1054 21.7071 14.2929C21.8946 14.4804 22 14.7348 22 15C22 15.2652 21.8946 15.5196 21.7071 15.7071C21.5196 15.8946 21.2652 16 21 16Z" fill="black" fill-opacity="0.5" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="3.5" stroke="#EEEEEE" />
    </svg>

    const CountryInsideEu = (CountryCode && this.euCountries.includes(CountryCode)) ? true : false;



    return (
      <>
        <div className="n_vox payment_page">
          <div className='split left'>
            <div className='centered'>
              <div className='spaced-between'>
             
                <a href="#" onClick={function () { window.history.go(-1) }}><span>{backIcon} &nbsp;&nbsp;Back</span></a>
                <b style={{ fontSize: 19 }}>{prop_info.name} 
                {/* {monthlyPrice} {prop_info.currency === 'eur' ? '€' : prop_info.currency} */}
                </b>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </div>
              <br />


              <div className='ricard'>
                <div className='spaced-between' style={{ marginBottom: 18, paddingBottom: 18, borderBottom: '1px solid rgba(84, 84, 84, 0.20)' }}>
                  <p>{prop_info.name}</p>
                  <p onClick={this.handleModalShow} style={{ color: '#35BFF4', cursor: 'pointer' }}>Includes {questionMarkIcon}</p>
                  <p>
                    {monthlyPrice}
                    {prop_info.currency === 'eur' ? '€' : prop_info.currency}&nbsp;/
                    {prop_info.recurrenceInterval ? 'monthly' : 'one time'}
                    {prop_info.type == 'one-time'  &&  prop_info.recurrenceInterval != 'month' ? 'one time' : ''}

                  </p>
                </div>

                <div>
                  <div className='spaced-between'>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <img src="/assets/images/physical_box.svg" width="57" height="66" alt="Placehold" />
                    </div>
                    

                    <div style={{ marginLeft: 40 }}>
                      {decrementIcon}
                      <input type="number" style={{ maxWidth: 140, marginTop: 10, paddingLeft: 65, paddingRight: 14 }} value={suggestion_counter} />
                      {incrementIcon}
                    </div>
                    <p style={{ marginTop: 18 }}>250€ /one time</p>
                  </div>

                  <div className='spaced-between'>
                    <p>Physical box<br />(Hallway vox)</p>
                  </div>
                </div>
                <div className='spaced-between' style={{ marginBottom: 22, paddingBottom: 0, borderBottom: '1px solid rgba(84, 84, 84, 0.20)', color: '#35BFF4' }}>
                  <p style={{ fontWeight: 'normal', fontSize: 13, textAlign: 'center' }}> Voxigamy is a cardboard pack that you build, add a tablet and you can enable your employees to vote on the Vox by just passing the hallway   </p>
                </div>

                <div className='spaced-between' style={{ display: 'none',borderBottom: '1px solid rgba(84, 84, 84, 0.20)', paddingBottom: '23px', marginBottom: '23px' }}>
                  <label><span style={{ color: '#35BFF4', fontWeight: 'normal' }}>Coupon Code</span>        <input type="text" name="card_email" placeholder="Enter coupon code" /></label>
                </div>

                <div className='spaced-between'>
                  <p style={{ color: '#545454', fontSize: 16 }}>Vat</p>
                  <p>{ (typeof(vatInfo !== null && vatInfo !== undefined) ? (vatInfo.tax_rate_percentage * ((suggestion_counter*250))).toFixed(2) : 0)} {prop_info.currency === 'eur' ? '€' : prop_info.currency}</p> 
                </div>
                
                <div className='spaced-between'>
                  <p style={{ color: '#545454', fontSize: 18 }}>
                    {prop_info.recurrenceInterval ? 'Monthly' : 'One time'} (excl. VAT)
                    {/* {prop_info.recurrenceInterval != 'month' ? 'One time payment' : ''} */}
                  </p>
                  <p>{monthlyPriceWithoutVat}</p>

                </div>

                <div style={{ color: '#545454', fontSize: 24 }} className='spaced-between'>
                  <p>Charged now</p>
                  {/* {vatInfo.tax_rate_percentage} */}
                  <p>{paymentNowPrice} {prop_info.currency === 'eur' ? '€' : prop_info.currency}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='split right container payment'>
            <div className='col-md-8 col-md-offset-3 text-center mx-auto' id='loginContainer'>


              <div className='form-group'>
                <form name='form' className="payment_form" onSubmit={this.handleSubmit}>

                  <b style={{ fontSize: 19 }}>Pay with card</b>
                  <br /> <br />
                  
                  <input type="hidden" name='monthlyPrice'     onChange={this.handleChange} value={monthlyPrice} />
                  <input type="hidden" name='paymentNowPrice' onChange={this.handleChange} value={paymentNowPrice} />
                
                  <label style={{display: 'none'}}>Username<input type="text" name="Username" value={Email} onChange={this.handleChange} placeholder={i18n.t('trans_33_enter_your_email')} /></label>

                  <label>E-mail<input type="email" disabled name="Email" value={Email} onChange={this.handleChange} placeholder={i18n.t('trans_33_enter_your_email')} /></label>
       
                  <label>Card Number <Elements stripe={stripePromise}><ElementsConsumer>{({ elements, stripe }) => (<StripeCardComponent elements={elements} stripe={stripe} onCardChange={this.onCardChange} />)}</ElementsConsumer></Elements></label>
                  <label>Name on card <input required type="text" onChange={this.handleChange} value={card_name} name="card_name" placeholder="Enter name on card" /></label>
                  
                  <label>

   Country <select required style={{ minHeight: '44px' }} onChange={this.handleChangeCountry} value={CountryCode} className="form-select" id="CountryCode" name="CountryCode"> 
   <option value="">Country</option>
   {Object.entries(this.countriesObj).map(([key, value]) => 
    <option value={key}>{value}</option>
   )}
   </select> 
</label>

    {CountryInsideEu && <p style={{fontSize: 12}}>This country is inside EU. Revalidate Vat ID for proper calculation, currently ({this.state.vatInfo.tax_rate_percentage*100}%).</p>}

                  <label>Vat ID
                  <div style={{display: 'flex', alignItems: 'baseline'}}><input type="text" disabled={vat_exempt} name="vat_id" value={this.state.vatInput} onChange={this.handleVatChange} placeholder="Enter Vat ID" />  
                  <button type="button" style={{maxWidth: '25%', marginLeft: 10, height: 45}} disabled={loadingVat} onClick={this.requestVatValidation}>Validate</button>
                  {loadingVat && (
                    <img alt='loading' src={imgLoading} />
                    )}
                  </div>
                  </label>
                  
                  <label style={{display: 'flex', alignItems: 'baseline', fontWeight: 100}}>
                  <input type='checkbox' name='vat_exempt' checked={vat_exempt? true : false} onChange={this.disableVat} style={{maxWidth: '20px'}}/> Vat exempt 
                  </label>
                  
                  <label>Billing Address  <input required type="text" name="billing_address" onChange={this.handleChange} value={billing_address} placeholder="Enter Billing Address" /></label>
                  <FormControlLabel required control={<Switch color="primary" name="savecard" checked={this.state.savecard} onChange={this.onChangeSaveCard} />} style={{fontWeight: 100}} label={!isMonthly? "I accept I will be charged every month ("+monthlyPriceWithoutVat+") for 12 consecutive months (non refundable)" : "I accept I will be charged every month ("+monthlyPriceWithoutVat+") until I cancel the plan."} />
                  <button className='landing-button  mt-4' disabled={loading || this.state.savecard === false}>Pay now {paymentNowPrice} {prop_info.currency === 'eur' ? '€' : prop_info.currency}
                  </button>
                  {loading && (
                  <img alt='loading' src={imgLoading} />
                  )}
                  <p style={{ marginTop: '12px', color: 'rgba(0, 0, 0, 0.70)', textAlign: 'center', fontSize: '12px' }}>By clicking ‘Pay’  you allow us to charge your card for this payment and future payments in accordances with their <a /*onClick={this.handleModalTosSimple}*/ style={{color: 'black'}} href="https://www.voxcollector.com/pdf/TOS.pdf"><b>Terms of service</b></a> and <a style={{color: 'black'}}href="https://www.voxcollector.com/pdf/privacy.pdf"><b>Privacy Policy</b></a>.You can always cancel your subscription </p>
                </form>
              </div>
              {error && <div className={'alert alert-danger'}>{error}</div>}
            </div>
          </div>
        </div>
        <ModalContent
          show={this.state.modalContent}
          theProps={prop_info}
          monthlyPrice={monthlyPrice}
          onHide={this.handleModalShow}
        />
            <ModalTosSimple
            show={this.state.modalTos}
            onHide={this.handleModalTosSimple}
            onTosAccepted={this.handleModalTosSimple}
        />
      </>
    );
  }


  onCardChange(card) {
    let formFields = this.state.formFields;
    formFields['card'] = card;
    this.setState({ formFields: formFields });
  }
  handleVatChange(e) {
    this.setState({ vatInput: e.target.value })
  }
doFetchCompany() {
    let IdCompany = this.state.user.IdCompany;

    return serverService.getCompany(this.state.user.IdCompany).then(
      (result) => {
        let company = result.data[0];
        let formFields = this.state.formFields;
        formFields['Email'] = company.Email;
        formFields['billing_address'] = company.billing_address;
        this.setState({ 
          formFields: formFields,
        });


        let formFieldsPayment = this.state.formFields['payment_methods'];
        this.setState({ company: company });
        if (result.status === "1") {
          serverService.paymentsGetPaymentMethods().then(
            (result) => {
              if (result.status !== "1") {
                console.log(result.message);
                //toast.error(result.message);
              } else {
                if (result.data.length > 0) {
                  this.setState({ formFields: result.data[0] });
                }
              }
            },
            (error) => {
              toast.warn("Did not get payment methods");
            }
          );
        } else {
          toast.error(result.message);
        }
      },
      (error) => {
        toast.warn("Did not get company");
      }
    );
  }
  requestVatValidation() {
    this.setState({ loadingVat: true });
      serverService.requestVatInfo(this.state.vatInput).then((result) => {
        if(result !== false){
          if(result.vat_details.valid == true)
          {
            if(result.vat_details.countryCode !== 'BE')
            result.vat_details.tax_rate_percentage = 0;
          this.setState({ vatInfo: result.vat_details });
          
          let formFields = this.state.formFields;
          formFields['billing_address'] = result.vat_details.address;
          this.setState({ 
            formFields: formFields, 
          });
          }
          else  
          toast.error(i18n.t('trans_33_vat_not_valid'));
        
       } 
       else
        toast.error(i18n.t('trans_33_vat_not_valid'));

        this.setState({ loadingVat: false });

      });
  }


}
export { PaymentPage };
